// extracted by mini-css-extract-plugin
export var container = "styles-module__container___OpWus";